import React from 'react';
import { FaLinkedin } from 'react-icons/fa';

const data = {
  name: "Mohammad Eyasin",
  title: "Technical Lead and Architect",
  // rating: 4.6,
  // reviews: "43,384 Reviews",
  // students: "446,675 Students",
  linkedin: "https://www.linkedin.com/in/yeasin-eng/",
  bio: `
  I'm a Tech Lead, Software Architect, and Course Instructor for the Back-End Engineering Program at Enginuity Systems. With over a decade of experience building scalable, enterprise-grade software for global clients, I’ve led full-cycle development across FinTech, EdTech, HRM, SaaS, and E-commerce platforms — including ERPs, payment gateways, and internal dev tools.

At Enginuity, I combine real-world software development with hands-on instruction to train future backend engineers. My teaching goes beyond just writing code — I focus on system architecture, scalability, DevOps workflows, and production-grade development. In this program, you'll gain the same engineering principles and architectural thinking I've applied to launch successful products and lead high-performing dev teams.
  `,
};

const InstructorCard = () => {
    return (
      <div className="w-full bg-white dark:bg-gray-900 rounded-lg p-6 mt-6">
        <h3 className="text-xlg font-bold dark:text-white mb-1">
          {data.name}
        </h3>
        <h3 className="text-lg text-purple-600 mb-1">{data.title}</h3>
        <p className="text-gray-700">{data.bio}</p>
        <div className="flex justify-center sm:justify-start gap-4 text-2xl text-gray-600 dark:text-gray-300  py-3">
          {data.linkedin && (
            <a href={data.linkedin} target="_blank" rel="noopener noreferrer" className="hover:text-purple-600">
              <FaLinkedin />
            </a>
          )}
        </div>
      </div>
    );
  };

export default InstructorCard;